var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-content-root",style:(_vm.areaStyle)},[_vm._l((_vm.hotZoneList),function(zone,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hotZoneList),expression:"hotZoneList"}],key:index,style:({
    position: 'absolute',
    zIndex: 10,
    top: zone.topPer * 100 + '%',
    left: zone.leftPer * 100 + '%',
    width: zone.widthPer * 100 + '%',
    height: zone.heightPer * 100 + '%'
  }),on:{"click":function($event){return _vm.jumpUrl(zone)}}})}),_c('div',{staticClass:"picture-article-container",on:{"click":function($event){return _vm.jumpUrl(_vm.specialEntry)}}},[(_vm.pictureBg)?_c('img',{staticClass:"picture-article-img",style:(_vm.pictureStyle),attrs:{"src":_vm.pictureBg,"alt":""}}):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }